import styled from 'styled-components';

export const HealthListStyled = styled.div`
  padding: ${props => props.theme.size.rap};
  background: #fff;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  height: 60vh;
  display: flex;
  flex-direction: column;

  .listTitle {
    font-size: 1.4rem;
    padding-bottom: 1rem;
  }
  .list {
    overflow: auto;
  }
  .listItem {
    display: flex;
    align-item: flex-start;
    width: 100%;
    padding: 1rem 0;
    border-bottom: 1px solid #ededed;
    .left {
      width: 20%;

      .image {
        width: 100%;
        aspect-ratio: 1 / 1;
        background: #ededed;
        border-radius: 1rem;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .right {
      width: 80%;
      padding-left: 1rem;

      .title {
        display: flex;
        align-items: center;
        gap: 1rem;
        font-weight: bold;
        margin-bottom: 0.25rem;
        line-height: 1em;
      }

      .description {
        margin-top: 0.5rem;
        font-size: 0.8rem;
        color: #333;
      }
    }
  }
`;

export const Color = styled.div<{
  color: string;
}>`
  position: relative;
  width: 0.5em;
  height: 0.5em;
  background: ${props => props.color};
  border-radius: 50%;

  &:after {
    width: 200%;
    height: 200%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid ${props => props.color};
    border-radius: 50%;
    content: '';
  }
`;
